export const splitPhoneNumberFormat = (number) => {
    if(number){
        const phone_number = number.replace('+91','')
        return `${phone_number.slice(0,4)}-${phone_number.slice(4,7)}-${phone_number.slice(7,10)}`
    }
   return ''
}